import { NodePositionChange, Node } from '@xyflow/react';
import { useCallback } from 'react';
import { RfNodeStickyNote } from '../../canvas-types/nodeTypesData';
import { ObjectOperations } from '../objectOperations';
import { SweepCanvasRfNode } from '../../canvas-types/nodeTypesData';
import { CanvasEventType, CanvasMoveStickyNoteEvent } from '../../canvas-types';
import { useSectionableNodeMoveEvent } from './useSectionableNodeMoveEvent';

export const useOnStickyNodePositionChange = () => {
  const { createSectionableNodeMoveEvent } = useSectionableNodeMoveEvent();

  const onStickyNodePositionChange = useCallback(
    ({
      nodeChange,
      node,
      nodeOperations,
      intersectionSectionNode,
      isResizing,
    }: {
      nodeChange: NodePositionChange;
      node: RfNodeStickyNote;
      nodeOperations: ObjectOperations<SweepCanvasRfNode>;
      intersectionSectionNode: Node | null;
      isResizing: boolean;
    }): CanvasMoveStickyNoteEvent | null => {
      nodeOperations.setObject(node.id, (node) => ({
        ...node,
        expandParent: !nodeChange.dragging && !isResizing,
      }));

      if (!nodeChange.dragging) {
        const moveEvent = createSectionableNodeMoveEvent({
          nodeChange,
          node,
          nodeOperations,
          intersectionSectionNode,
        });
        if (!moveEvent) {
          return null;
        }

        return {
          type: CanvasEventType.MoveStickyNote,
          id: moveEvent.nodeId,
          xyPosition: moveEvent.xyPosition,
          parentId: moveEvent.parentId || null,
        };
      }
      return null;
    },
    [createSectionableNodeMoveEvent],
  );

  return {
    onStickyNodePositionChange,
  };
};
